import axiosInstance, { axiosPublicInstance } from "../config/AuthInterceptors";
import { IAreaExpertiseBody, IAreaExpertiseGenericResponse, IAreaExpertiseGetListResponse } from "../interfaces/areaExpertise";

const areaExpertiseService = {
    getAll: (skip: number = 0, limit: number = 25) => axiosInstance.get<IAreaExpertiseGetListResponse>("/areas?skip=" + skip + "&limit=" + limit).then(res => res.data),
    getAllForRegister: () => axiosPublicInstance.get<IAreaExpertiseGetListResponse>("/areas").then(res => res.data),
    get: (id: string) => axiosInstance.get<IAreaExpertiseGenericResponse>("/areas/" + id).then(res => res.data),
    post: (body: IAreaExpertiseBody) => axiosInstance.post<IAreaExpertiseGenericResponse>("/areas", body).then(res => res.data),
    put: (id: string, body: IAreaExpertiseBody) => axiosInstance.put<IAreaExpertiseGenericResponse>("/areas/" + id, body).then(res => res.data),
    delete: (id: string) => axiosInstance.delete<IAreaExpertiseGenericResponse>("/areas/" + id).then(res => res.data),
}

export default areaExpertiseService; 